var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { loadItemsAsyncPrefix, reduxNestedKeys, actionTypes } from "./module/views/SrmDebugView/ducks/SrmDebug.ducks.types.js";
import SrmDebugResource from "./module/views/SrmDebugView/resources/SrmDebug.resource.js";
import { ROUTES } from "@ane/exp-data/lib/routes/Routes.constants";
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import { SrmDebugContextParams } from "./module/views/SrmDebugView/utils/SrmDebugContext.js";
import SrmDebugConstants from "./module/views/SrmDebugView/models/SrmDebugConstants.js";
const provideSrmDebugEpics = (history) => {
  const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(
    SrmDebugContextParams,
    (context) => setContextAction(context),
    SrmDebugConstants.SET_PARTIAL_CONTEXT,
    SrmDebugConstants.SET_CONTEXT,
    (store) => store.srmDebugContext,
    history,
    (pathname) => !!pathname && pathname.startsWith(`${ROUTES.srmDebug.location.pathname}`),
    EXP_QUERY_STRINGS
  );
  return combineEpics(itemsAsyncEpicReducer.epic, ...Object.values(setUserContextFromRouteQueryString));
};
const itemsAsyncEpicReducerArg = {
  actionPrefix: loadItemsAsyncPrefix,
  reduxKeyNested: () => [reduxNestedKeys.itemsAsyncKey],
  loadResource: (inputPayload) => SrmDebugResource.getSrmDebugCheckRestResult(inputPayload.request, inputPayload.workspaceId),
  onCompleteSuccess: (result, input) => result
};
const itemsAsyncEpicReducer = loadResourcesUtils(itemsAsyncEpicReducerArg);
const defaultReducerState = {
  error: "",
  srmDebugContext: {
    treatment: "",
    control: "",
    primarySegmentName: "",
    primarySegmentValue: "",
    nochrome: false,
    multipleScorecards: "",
    workspaceId: ""
  },
  itemsAsync: getDefaultAsyncWrapperObj()
};
const reducer = (state = defaultReducerState, action) => {
  state = itemsAsyncEpicReducer.reduxChange(state, action);
  switch (action.type) {
    case actionTypes.SET_CONTEXT:
      let setContextAction2 = action;
      return __spreadProps(__spreadValues({}, state), {
        srmDebugContext: setContextAction2.payload
      });
    default:
      return state;
  }
};
const setContextAction = (context) => {
  return {
    type: actionTypes.SET_CONTEXT,
    payload: context
  };
};
const setPartialContextAction = (context) => {
  return {
    type: actionTypes.SET_PARTIAL_CONTEXT,
    payload: context
  };
};
export {
  setPartialContextAction as a,
  defaultReducerState as d,
  itemsAsyncEpicReducer as i,
  provideSrmDebugEpics as p,
  reducer as r,
  setContextAction as s
};
//# sourceMappingURL=SrmDebug.ducks-944cbd53.js.map
